import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';
import { Alert, Button } from 'antd';

// TODO: need a better grid gap solution than 98%
export const DimensionTableWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;
  flex-grow: 0;
  border-radius: 6px;
  height: 100%;
  border: 1px solid #e5e5e5;

  &:hover {
    .remove-dimension-btn {
      opacity: 1;
    }

    .drag-handle {
      opacity: 1;
    }
  }
`;

export const StyledEllipsis: any = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 200;
  max-width: 90%;
  padding-top: 3px;
  cursor: pointer;
  user-select: all;

  .copy-cell-text {
    display: none;
    padding-left: 5px;
  }

  .quick-compare-action {
    display: none;
  }

  &:hover {
    color: #1c78db;

    .copy-cell-text {
      display: inline-block;
    }

    .quick-compare-action {
      display: inline-flex;
    }
  }
`;

export const StyledCell = styled.div<{ pctShare?: number; showTrend?: boolean }>`
  height: 100%;
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.showTrend ? 'space-evenly' : 'right')};
  ${(props) =>
    props.pctShare
      ? `background: linear-gradient(90deg, #BDDFFB ${props.pctShare}%, transparent ${props.pctShare}%, transparent ${100 - props.pctShare}%)`
      : 'none'};
`;

export const StyledTrendWrapper = styled.div`
  width: 60px;
  text-align: right;

  svg {
    width: 12px;
    height: 14px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 5px;
  flex-grow: 1;

  /* stylelint-disable-next-line selector-class-pattern */
  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const StyledCloseBtn = styled(Button)`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const DimensionTitle = styled.div`
  font-size: 14px;
  padding: 3px;
`;

export const StyledSearch = styled.div`
  .ant-input {
    border-color: #585759 !important;
    position: absolute;
    left: 5px;
    top: 0;
    height: 29px;
    width: 140px;
  }

  .ant-input-affix-wrapper {
    height: 32px;
    position: relative;
    border-radius: 6px !important;
  }

  .ant-btn {
    border: none;
    box-shadow: none;
    margin-left: 3px;
  }

  .ant-input-suffix {
    position: absolute;
    right: 5px;
    z-index: 99;
  }
`;

export const StyledSelector = styled.div`
  margin-top: -5px;
  margin-left: -5px;
  background-color: #f8fafb;
  width: fit-content;
  border-bottom: 1px solid #e5e9ec;
  border-right: 1px solid #e5e9ec;
  border-top-left-radius: 6px;

  .ant-select-selection-item {
    font-weight: 500;
  }
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-weight: 400;
  color: ${(props) => (props.selected ? '#0046ff' : 'unset')};
  align-self: center;
`;

export const ErrorDiagnosticsIconWrapper = styled.span`
  margin-right: 5px;

  &:hover {
    color: #0046ff;
  }
`;

export const StyledAlert = styled(Alert)`
  width: max-content;
  height: 30px;
  margin-bottom: 5px;
`;

export const ColHeader = styled.div`
  font-size: 12px;
  font-weight: 500;
`;

export const ColHeaderText = styled.span`
  color: ${(props) => (props.highlight ? '#bd10e0' : 'unset')};
`;

export const ActionBar = styled.div`
  position: absolute;
  right: 25px;
  background: #e9f3fd;
  margin-left: 5px;
`;

export const ActionCellWrapper = styled.div`
  border-left: 3px solid transparent;
  padding-left: 5px;
  display: flex;
  width: 100%;
  background: #f8f8f8;
  height: 100%;
`;

export const WidgetActions = styled.div`
  position: absolute;
  right: 36px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 5px;
`;
